var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module",class:_vm.$parent.data && _vm.$parent.data.contextual ? 'contextual' : ''},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }